import { useState } from 'react'
import { Dialog } from '#app/shared/ui/popups/Dialog.js'
import DetailsModalContent from './detailsModalContent'

type Props = {}

export default function DetailsModal({}: Props) {
  const [open, setOpen] = useState(false)
  return (
    <Dialog
      className={`
        hidden !rounded-none !border-0 !border-none

        md:block
      `}
      overlayClassName="!rounded-none !border-0 !border-none bg-transparent"
      open={open}
      onClose={() => setOpen(false)}
      hideIcon
      containerClassName="overflow-hidden !border-none"
      variant="fullscreen"
    >
      <DetailsModalContent setOpen={setOpen} />
    </Dialog>
  )
}
